// Listed up front; the view itself (./notation-viewer.tsx) loads on demand.
export const id = 'notation-viewer';
export const title = 'Notation viewer';
export const order = 95;
